import SectionHeading from "./SectionHeading";
import { hotRank } from "@/mocks/mayiBaoliao";

export default function HotRank() {
  return (
    <section id="hot" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          over="Heatboard · 今日热榜"
          title="此刻最该知道的那些事"
          desc="按讨论热度排序，榜单项均来自实时投稿与实况交叉核实，给你快速判断的依据。"
          linkHref="#live"
          linkLabel="看完整快讯流"
        />

        <div className="mt-9 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {hotRank.map((item) => (
            <a
              key={item.rank}
              href="#live"
              className="group flex w-full items-start gap-4 rounded-lg border border-background-200 bg-background-100/60 p-4 transition hover:border-secondary-300 hover:bg-background-100 md:p-5"
            >
              <div className="flex w-9 shrink-0 justify-center">
                <span
                  className={`font-heading text-3xl font-black leading-none ${
                    item.rank <= 3 ? "text-secondary-500" : "text-background-400"
                  }`}
                >
                  {String(item.rank).padStart(2, "0")}
                </span>
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
                    {item.tag}
                  </span>
                  <span className="flex items-center gap-0.5 text-xs text-primary-600">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-fire-line text-sm" />
                    </span>
                    {item.heat.toFixed(1)}
                  </span>
                </div>
                <h3 className="mt-2 font-medium leading-snug text-foreground-950 transition group-hover:text-foreground-700">
                  {item.title}
                </h3>
                <p className="mt-1.5 hidden text-sm text-foreground-600 sm:block">{item.note}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}